import { LiveOrdersData } from '../../models/LiveOrders';

const useLiveOrders = () => {
    const createData = (
        orderNumber: string,
        date: string,
        price_net: string,
        price_gross: string,
        status: string
    ): LiveOrdersData => {
        return {
            orderNumber,
            date,
            price_net,
            price_gross,
            status,
        };
    };
    const getLiveOrders = () => {
        return [
            createData('NYK/33222811', '2021.12.11', '80000', '110000', 'paid'),
            createData('NYK/33222811', '2021.12.11', '80000', '110000', 'paid'),
            createData('NYK/33222811', '2021.12.11', '80000', '110000', 'paid'),
            createData('NYK/33222811', '2021.12.11', '80000', '110000', 'paid'),
            createData('NYK/33222811', '2021.12.11', '80000', '110000', 'paid'),
            createData('NYK/33222811', '2021.12.11', '80000', '110000', 'paid'),
        ];
    };

    return {
        getLiveOrders,
    };
};

export default useLiveOrders;
